<template>
  <a-modal
    :width="1000"
    :visible="visible"
    title="任务详情"
    @ok="cancel"
    @cancel="cancel"
  >
    <a-button type="primary" icon="export" @click="handleExport()"
      >导出
    </a-button>
    <a-descriptions
      :title="workerName"
      :column="3"
      bordered
      style="margin-top:16px"
    >
    </a-descriptions>
    <s-table
      ref="table"
      size="default"
      rowKey="id"
      :columns="columns"
      :data="loadData"
      showPagination="auto"
    >
      <template slot="serial" slot-scope="value, row, index">
        {{ index + 1 }}
      </template>
      <template slot="actions" slot-scope="record">
        <a @click="handleDetail(record)">详情</a>
      </template>
    </s-table>
    <detail ref="detail" />
  </a-modal>
</template>
<script>
import { STable } from "@/components";
import detail from "./modules/detail";
import { exportDetail } from "@/api/base/statistical/resource";

const columns = [
  {
    title: "#",
    scopedSlots: { customRender: "serial" }
  },
  // {
  //   title: "任务名称",
  //   dataIndex: "workerName"
  // },
  // {
  //   title: "资源名称",
  //   ellipsis: true,
  //   dataIndex: "resourceName"
  // },
  {
    title: "负责人",
    dataIndex: "personName"
  },
  {
    title: "任务截止时间",
    dataIndex: "endTime"
  },
  // {
  //   title: "上传时间",
  //   dataIndex: "uploadTime"
  // },
  // {
  //   title: "附件",
  //   dataIndex: "resourceUrl"
  // },
  {
    title: "完成情况",
    customRender: (value, row) => {
      if ("Y" == row.comStatus) {
        if (new Date(row.uploadTime) > new Date(row.endTime)) return "延期完成";
        return "已完成";
      } else if ("N" == row.comStatus) {
        if (new Date() > new Date(row.endTime)) return "已延期";
        return "未完成";
      }
    }
  },
  {
    title: "操作",
    scopedSlots: { customRender: "actions" }
  }
];

export default {
  components: {
    STable,
    detail
  },

  data() {
    return {
      //modal
      visible: false,
      modal: {},

      // 标题名称为任务名称
      workerName: "",

      columns,

      // 查询参数
      queryParam: {},
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        let that = this;
        return new Promise(resolve =>
          resolve({
            object: null,
            page: params.page,
            records: that.modal.sunWorkerDtoList.length,
            rows: that.modal.sunWorkerDtoList,
            total: that.modal.sunWorkerDtoList.length
          })
        ).then(res => res);
      }
    };
  },
  methods: {
    show(modal) {
      console.log(" === statistics task show: ", modal);

      this.visible = true;

      if (modal) {
        // 设置任务名称
        this.workerName = modal.workerName;
        // 设置表格数据
        this.modal = modal;

        // 刷新数据表格
        this.$nextTick(function() {
          this.$refs.table.refresh(true);
        });
      }
    },
    cancel() {
      this.visible = false;
      this.modal = {};
    },

    // 查看详情
    handleDetail(record) {
      this.$refs.detail.show({
        workerName: this.modal.workerName,
        content: this.modal.content,
        startTime: this.modal.startTime,
        endTime: this.modal.endTime,
        id: record.id,
        arrIds: record.arrIds
      });
    },

    // 导出
    handleExport() {
      exportDetail({
        workerId: this.modal.id,
        etime: this.modal.endTime,
        workerName: this.modal.workerName
      }).then(result => {
        // console.log(" === statistical detail handleExport === ");

        if (result.code == 0) {
          window.location.href =
            window._CONFIG["downloadURL"] +
            "?fileName=" +
            result.msg +
            "&delete=" +
            true;
        } else if (result.code == 1) {
          this.$notification.error({ message: result.msg });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fileItem {
  margin: 6px 0;
}
</style>
